export default __webpack_public_path__ + "static/media/travel-S.fe369f15.jpg";